export { default } from './RegisterManage';
